import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Work", to: "/our-work" },
  { label: "Features", to: "/features" },
  { label: "Projects", to: "/projects" },
  { label: "Media", to: "/media" },
  { label: "Join Us", to: "/join-us" },
  { label: "Campaign", to: "/campaign" },
  { label: "Donate", to: "/donate" },
  { label: "Blog", to: "/blog" },
  { label: "Contact Us", to: "/contact" }
];

function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");

  const handleToggle = () => setIsOpen((prev) => !prev);
  const handleNavClick = () => setIsOpen(false);

  useEffect(() => {
    const storedEmail = localStorage.getItem("email") || "";
    const storedRole = localStorage.getItem("role") || "";
    setUserName(storedEmail);
    setRole(storedRole);
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.clear();
    setUserName("");
    setRole("");
    navigate("/");
  };

  const isLoggedIn = Boolean(localStorage.getItem("token"));

  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="container header-inner">
        <div className="logo">
          <div className="logo-mark">HF</div>
          Hope Foundation
        </div>

        <div className="header-actions">
          {isLoggedIn ? (
            <>
              <span className="user-chip">Hello {userName || "there"} !!</span>
              {role && ["admin", "staff"].includes(role) && (
                <NavLink to="/dashboard" className="btn btn-ghost" onClick={handleNavClick}>
                  Dashboard
                </NavLink>
              )}
              <button className="btn btn-ghost" type="button" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login" className="btn btn-ghost" onClick={handleNavClick}>
                Login
              </NavLink>
              <NavLink to="/register" className="btn btn-ghost" onClick={handleNavClick}>
                Sign Up
              </NavLink>
            </>
          )}
          <NavLink to="/donate" className="btn btn-secondary" onClick={handleNavClick}>
            Donate Now
          </NavLink>
          <NavLink to="/get-involved" className="btn btn-primary" onClick={handleNavClick}>
            Get Involved
          </NavLink>
          <button className="nav-toggle" onClick={handleToggle} aria-expanded={isOpen}>
            Menu
          </button>
        </div>
      </div>
      <div className="nav-strip">
        <div className="container">
          <nav className={`nav ${isOpen ? "open" : ""}`} aria-label="Primary">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} onClick={handleNavClick}>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default SiteHeader;
